var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"fluid":"","loading":_vm.IsAthleteLoading}},[(_vm.IsAthleteLoading)?_c('LoadingWait',{attrs:{"text":"Loading Schedule"}}):_c('AthleteScheduleCard',{attrs:{"showPast":"","showEdit":"","athleteProfile":_vm.TheAthleteProfile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }